import { useState } from "react";
import {
    BlockStack,
    Text,
    Grid,
    InlineStack,
    Button,
    useTranslate,
} from "@shopify/ui-extensions-react/customer-account";
import { SeatSlot, ItemUploadSectionProps } from "../types";
import { SlotUploadControl } from "./SlotUploadControl";

export const ItemUploadSection = ({
    requirement,
    files,
    fileProgress,
    onFileSelect,
    onRemove,
    isUploading,
    defaultExpanded = false,
}: ItemUploadSectionProps) => {
    const [expanded, setExpanded] = useState(defaultExpanded);
    const translate = useTranslate();

    const getColumns = (count: number): ('auto' | 'fill' | `${number}%` | `${number}fr`)[] => {
        if (count === 1) return ['100%'];
        if (count === 2 || count === 4) return ['50%', '50%'];
        return ['33%', '33%', '33%'];
    };

    const columns = getColumns(requirement.slots.length);

    return (
        <BlockStack spacing="base" padding="base" border="base" cornerRadius="base">
            <Grid columns={['1fr', 'auto']} spacing="base" blockAlignment="center">
                <BlockStack spacing="none">
                    <Text emphasis="bold" size="medium">{requirement.itemTitle}</Text>
                    <Text appearance="subdued">{requirement.seatType.replace(/_/g, ' ')}</Text>
                </BlockStack>
                <Button kind="plain" onPress={() => setExpanded(!expanded)}>
                    {expanded ? translate('slotUpload.hide') : translate('slotUpload.show')}
                </Button>
            </Grid>

            {expanded && (
                <Grid columns={columns} spacing="loose">
                    {requirement.slots.map((slot: SeatSlot) => (
                        <SlotUploadControl
                            key={slot.id}
                            slot={slot}
                            file={files[slot.id] || null}
                            progress={fileProgress[slot.id]}
                            onFileSelect={onFileSelect}
                            onRemove={onRemove}
                            disabled={isUploading}
                        />
                    ))}
                </Grid>
            )}
        </BlockStack>
    );
};
